export default "__VITE_ASSET__CJFPKAF7__"